import styled from "styled-components";

import { Typography } from "@/foundation/Typography/V2";

export const StyledBadge = styled(Typography)`
  position: absolute;
  top: 16px;
  left: 16px;
  padding: 8px 16px;
  border-radius: 8px;
  background-color: ${({ bgColor }) => bgColor};
  text-transform: capitalize;
`;
